module.exports = __webpack_public_path__ + "static/media/69.ca749c26.gif";